import { typographyTokens } from '../../theme/typographyTokens';
import React, { useEffect } from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';
import { useNavigate, useLocation } from 'react-router';
import { usePartialSepQuery } from '../../services/sepSlice';
import { useGetUserQuery } from '../../services/usersSlice';
import { LoadingContainer } from '../../containers/LoadingContainer';
import { CreateSEP } from './CreateSEP';

const Redirect = () => {
  // let validUser = ''
  const user = useGetUserQuery('me');
  const {
    data: SEPSearch,
    isLoading,
    error,
  } = usePartialSepQuery(
    user.data !== undefined ? user.data.id : 'no user found',
    { skip: !user.isSuccess, refetchOnMountOrArgChange: true }
  );
  const navigate = useNavigate();
  const location = useLocation();
  const editSep = location?.state?.condition;

  useEffect(() => {
    if (editSep !== null && editSep === 'edit') {
      return;
    } else if (SEPSearch !== undefined && SEPSearch.count > 0) {
      navigate(`/knockout/${SEPSearch?.seps[0].id}`);
    }
  }, [editSep, SEPSearch, navigate]);

  if (isLoading) {
    return (
      <>
        <LoadingContainer>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            minHeight="60vh"
            width="100%"
          >
            <CircularProgress size={100} />
            <Typography variant="h5" sx={{ fontWeight: typographyTokens.fontWeights.bold, mt: 5 }}>
              Checking for previously created SEPs...
            </Typography>
          </Box>
        </LoadingContainer>
      </>
    );
  }

  if (error && SEPSearch === undefined) {
    return <>Something went wrong...</>;
  }

  return <>{SEPSearch && <CreateSEP {...SEPSearch} />}</>;
};

export default Redirect;
